import RoutePath from '../../../pure-js/libs/RoutePath'
import { SignedInSteps } from '../../../pure-js/types/SignedInTypes'
import SignedIn from '../components/SignedIn'
import { useNavigate } from '../hooks/useNavigate'

export const InvitePage = () => {
  const navigate = useNavigate()
  return <SignedIn step={SignedInSteps.INVITE_TO_TEAM} onClickLater={() => navigate(RoutePath.DASHBOARD)} />
}
